"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISIBLE_GAMES_COUNT_OFFSET = exports.INITIAL_VISIBLE_GAMES = void 0;
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_2 = require("@l2p/ui-components");
var ui_components_3 = require("@l2p/ui-components");
var ui_components_4 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var ui_components_5 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_6 = require("@l2p/ui-components");
exports.INITIAL_VISIBLE_GAMES = 18;
exports.VISIBLE_GAMES_COUNT_OFFSET = 18;
var CARD_CLASS_NAME = 'game-card';
var BlockWithGames = function (_a) {
    var title = _a.title, games = _a.games, gameCardPlaceholder = _a.gameCardPlaceholder;
    var _b = (0, react_1.useState)(exports.INITIAL_VISIBLE_GAMES), visibleGames = _b[0], setVisibleGames = _b[1];
    var t = (0, next_intl_1.useTranslations)('translation');
    var _c = (0, react_1.useState)(''), searchValue = _c[0], setSearchValue = _c[1];
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var onSearchChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        setSearchValue(target.value);
    }, []);
    var searchClear = (0, react_1.useCallback)(function () {
        setSearchValue('');
    }, []);
    var handleLoadBtnClick = (0, react_1.useCallback)(function () {
        if (visibleGames) {
            setVisibleGames(visibleGames + exports.VISIBLE_GAMES_COUNT_OFFSET);
        }
    }, [visibleGames]);
    var filteredGames = (0, react_1.useMemo)(function () {
        if (!games)
            return [];
        return (0, apps_shared_1.filterGamesByTitle)(games, searchValue);
    }, [games, searchValue]);
    var gamesToShow = (0, react_1.useMemo)(function () { return filteredGames.slice(0, visibleGames); }, [filteredGames, visibleGames]);
    if (!games)
        return react_1.default.createElement(ui_components_5.LoadingWithContainer, null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        !breakpoints.mobile && !breakpoints.tablet ? (react_1.default.createElement(ui_components_3.SearchWithTitle, { title: title, value: searchValue, searchClear: searchClear, onSearchChange: onSearchChange })) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title)),
        gamesToShow.length > 0 ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.gamesContainer },
            gamesToShow.map(function (item) {
                var _a;
                return (react_1.default.createElement("div", { key: "provider_page".concat(item.id, "}") }, Object.keys(breakpoints).length > 0 &&
                    (breakpoints.mobile || breakpoints.tablet) ? (react_1.default.createElement(ui_components_2.MobileGameCard, { title: item.title, gameId: item.id, slug: item === null || item === void 0 ? void 0 : item.slug, className: CARD_CLASS_NAME, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL })) : (react_1.default.createElement(ui_components_2.DesktopGameCard, { title: item.title, gameId: item.id, slug: item.slug, withDemo: (_a = item === null || item === void 0 ? void 0 : item.settings) === null || _a === void 0 ? void 0 : _a['demo'], className: CARD_CLASS_NAME, gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL }))));
            }),
            filteredGames.length > exports.INITIAL_VISIBLE_GAMES &&
                gamesToShow.length < filteredGames.length &&
                gamesToShow.length !== 0 && (react_1.default.createElement(ui_components_6.LoadMoreMask, { cardClassName: CARD_CLASS_NAME },
                react_1.default.createElement(ui_components_1.LoadMoreButton, { onClick: handleLoadBtnClick }, t('loadMore')))))) : (react_1.default.createElement(ui_components_4.EmptyGames, null))));
};
exports.default = BlockWithGames;
